/* global jarallax */

import 'jarallax/dist/jarallax'
import each from 'lodash/each'

function setupParallaxOnEl(el) {
  const speed = el.dataset.parallaxSpeed !== undefined ? parseFloat(el.dataset.parallaxSpeed) : 0.5
  jarallax(el, { speed })
}

function setupParallax(container) {
  if (!container) {
    return
  }

  // Initialize existing elements:

  const existingEls = container.querySelectorAll('.parallax')
  if (existingEls.length) {
    each(existingEls, (el) => {
      setupParallaxOnEl(el)
    })
  }

  // Observe new elements:

  const observer = new MutationObserver((mutations) => {
    each(mutations, (mutation) => {
      each(mutation.addedNodes, (node) => {
        if (node.nodeType !== 1) {
          return
        }

        const els = node.querySelectorAll('.parallax')
        if (!els.length) {
          return
        }

        each(els, (el) => {
          setupParallaxOnEl(el)
        })
      })
    })
  })

  observer.observe(container, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false,
  })
}

export { setupParallax }
